import React from 'react';
import { translate } from 'react-i18next';
import { NavLink, withRouter } from 'react-router-dom';
import { Button, Icon, List, Select } from 'antd';

import { getShortKey } from '../../../../modules/activities-management';
import { KEY_NEW, KEY_COPY } from '../ActivityEdit/ActivityEdit';
import './activitiesList.scss';

const { Option } = Select;

export class ActivitiesList extends React.Component {
  state = {
    selectedCategory: '',
  }

  selectCategory = selectedCategory => this.setState({ selectedCategory })

  render () {
    const {
      listPath,
      activities,
      categories,
      location: { pathname },
      t,
    } = this.props;
    const { selectedCategory } = this.state;
    const { selectCategory } = this;

    return (
      <div className="fms-activities-list">
        <div className="fms-activities-list__header">
          <h1>Liste des activités</h1>
          <NavLink to={`${pathname}/${KEY_NEW}`.replace(/\/\//g, '/')}>
            <Button
              type="primary"
              icon="plus"
            >
              Nouvelle activité
            </Button>
          </NavLink>
        </div>
        <div>
          Filtrer par catégorie&nbsp;:
          <br />
          <Select value={selectedCategory} onChange={selectCategory}>
            <Option value="">Toutes</Option>
            {categories.map(category => (
              <Option value={category} key={category}>{t('activity.category.label', { context: category })}</Option>
            ))}
          </Select>
        </div>
        <nav>
          <List
            dataSource={
              activities.filter(({ value: { category } }) =>
                !selectedCategory || selectedCategory === category)
            }
            renderItem={
              ({ key, value: { label, category } }) => (
                <List.Item className="fms-activities-list__item">
                  <List.Item.Meta
                    title={(
                      <NavLink
                        to={`${listPath}/${getShortKey(key)}`}
                      >
                        <div className="item">
                          <Icon className="item__icon" type="edit" />
                          <div className="item__content">
                            <strong className="item__label">{label}</strong>
                            <span className="item__category">{t('activity.category.label', { context: category })}</span>
                          </div>
                        </div>
                      </NavLink>
                  )}
                  />
                  <NavLink
                    className="copy-button"
                    to={`${pathname}/${KEY_COPY}${getShortKey(key)}`.replace(/\/\//g, '/')}
                  >
                    <Button
                      type="default"
                      icon="copy"
                    >
                      Copier
                    </Button>
                  </NavLink>
                </List.Item>
              )}
          />
        </nav>
      </div>
    );
  }
}

export default withRouter(translate()(ActivitiesList));



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivitiesList/ActivitiesList.js